import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
      <a className='foot-link left' href='mailto:test@gmail.com'>
        sales@fashion.com
      </a>
      <p className='footer-text'>Fancy brand</p>
      <a className='foot-link right' href='https://www.instagram.com/'>
        @fashion
      </a>
    </div>
  )
}

export default Footer
